export const FilterType = {
  SELECT: "select",
  MULTI_SELECT: "multi-select",
  BOOLEAN: "boolean",
  DATE: "date",
  INPUT: "input",
} as const;
export type FilterType = (typeof FilterType)[keyof typeof FilterType];
